<template>
  <div class="page-content">
     <el-tabs type="border-card" @tab-click="tabClick" v-model="activeName" class="tableContent">
      <el-tab-pane label="任务列表" name="0">
          <!-- <keep-alive> -->
             <!-- 切换到对应的tab再加载组件，keep-alive保证重新切换回来不会重新加载 -->
            <taskList
            v-if="activeName=== '0'"
            :properties="thingModel.properties"
            :deviceDetail="deviceDetail"></taskList>
          <!-- </keep-alive> -->
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="1">
          <!-- <keep-alive> -->
            <operationLog
            :deviceDetail="deviceDetail"
            :events="thingModel.events"
            v-if="activeName=== '1'"/>
          <!-- </keep-alive> -->
        </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import taskList from '@/components/dataList/taskList.vue'
import operationLog from '@/components/dataList/operationLog.vue'
import { eventBus } from '@/utils/eventBus'
import { thingModel } from '@/api/deviceManagement'
export default {
  props: ['deviceDetail'],
  data () {
    return {
      activeName: '0',
      thingModel: {
        events: '', // 事件
        properties: '', // 属性
        services: ''// 服务
      }
    }
  },
  created () {
    // this.getThingModel()
  },
  methods: {
    tabClick (tab) {
      tab.name !== '0'
        ? eventBus.$emit('clearFreshInterval')
        : ''
    },
    getThingModel () {
      const params = {
        productKey: 'R589hUgZrO8'
        // productKey: this.deviceDetail.productKey
      }
      console.log('getThingModel params:', params)
      this.key2chinese = {}
      this.dataList = []
      thingModel(params).then(res => {
        res = res.data
        console.log('外层物模型数据：', res)
        Object.assign(this.thingModel, res.data.thingModel)
        // res.data.thingModel.properties.map(item => {
        //   const model = {
        //     name: item.name,
        //     unitName: item.dataType.specs.unitName,
        //     dataType: item.dataType,
        //     // 以下的字段主要用查看数据调用接口所用
        //     propertyName: item.identifier
        //   }
        //   this.key2chinese[item.identifier] = model
        //   // 物模型得数据获取到后就先展示
        //   if (item.identifier !== 'ipaddress' && item.identifier !== 'activationTime' && item.identifier !== 'deviceStatus') {
        //     this.dataList.push(model)
        //   }
        // })
        // console.log('处理后的数据：', this.key2chinese)
      })
      console.log('await后面')
    }
  },
  components: {
    taskList,
    operationLog
  }
}
</script>
<style lang="less" scoped>
.page-content{
  .tableContent{
    margin-top: 20px;
    /deep/ .el-tabs__item.is-active{
      color: #FFF;
      background-color: #0070cc;
    }
  }
}
</style>
